const s = {
  name: "Vr",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,2h8V0h-8V2z"/>
		<path class="st0" d="M28,8h3c1.7,0,3,1.3,3,3v3h-2v-3c0-0.5-0.5-1-1-1h-3V8z"/>
		<path class="st0" d="M37.9,10c-0.5-3.4-3.4-6-6.9-6H9c-3.9,0-7,3.1-7,7v3l-2,0l0,2l2,0v3c0,3.9,3.1,7,7,7h5.9
			c1.7,0,3.2-1.2,3.6-2.8c0.2-0.7,0.8-1.2,1.5-1.2c0.7,0,1.3,0.5,1.5,1.2c0.4,1.7,1.9,2.8,3.6,2.8H31c3.9,0,7-3.1,7-7v-3l2,0l0-2
			l-2,0L37.9,10L37.9,10z M9,6h22c2.8,0,5,2.2,5,5v1h0v7c0,2.8-2.2,5-5,5h-5.9c-0.8,0-1.5-0.5-1.7-1.3l0,0C23.1,21.1,21.6,20,20,20
			c-1.6,0-3.1,1.1-3.5,2.7l0,0c-0.2,0.8-0.9,1.3-1.7,1.3H9c-2.8,0-5-2.2-5-5v-8C4,8.2,6.2,6,9,6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Vr
};
